// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { searchBoxStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchBox";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import Search from "@mcmc/XDL/Icons/Search";
import { css } from "styled-components";

searchBoxStyles.search = {
    iconProps: {
        src: Search,
        css: css`
            color: ${getColor("primary")};
            left: 2px;
        `,
    },
    cssOverrides: {
        inputSelect: css`
            ${getProp("theme.formField.defaultProps.cssOverrides.inputSelect")}
            padding-left: 33px !important;
        `,
    },
    label: translate("Search"),
};
